import React, { useState } from "react";
import { useForm } from "react-hook-form";
import "../admin.css";

const RejectRemarkForm = (props) => {
	const { register, handleSubmit, errors } = useForm();

	const onSubmit = (data) => {
		const sanitizedStr = data.reject_remark.trim();
		if (sanitizedStr != "") props.updateInvoiceStatus("REJECT", sanitizedStr);
		else props.updateInvoiceStatus("REJECT", null);
	};

	return (
		<div style={{ display: "block" }}>
			<div id="remark-form">
				<form onSubmit={handleSubmit(onSubmit)}>
					<fieldset>
						<legend>
							Remark{" "}
							{errors.reject_remark &&
								errors.reject_remark.type === "required" && (
									<span className="required">*required</span>
								)}
						</legend>

						<textarea
							rows="10"
							cols="110"
							name="reject_remark"
							aria-invalid={errors.reject_remark ? "true" : "false"}
							ref={register({ required: true })}
						/>
					</fieldset>
					<div className="btn-container">
						<button
							type="submit"
							className="btn btn-primary btn-generate btn-approval"
						>
							Submit
						</button>
					</div>
				</form>
			</div>
		</div>
	);
};

export default RejectRemarkForm;
